import React, { useEffect, useState } from "react";
import { BiTrash } from "react-icons/bi";
import styles from "./sort-section.module.css";

/**
 * SortItem Component
 * 
 * Individual sort condition item with field selector and sort order selector.
 * Automatically updates available sort order options based on field data type.
 * Updates parent array when field or sort order changes.
 * 
 * @param {Object} props - Component props
 * @param {number} props.id - Condition ID for array indexing
 * @param {Object} props.field - Current field object with actualName and type
 * @param {Array} props.fields - Available fields for sorting
 * @param {Function} props.update - Callback to update sort condition
 * @param {Function} props.remove - Callback to remove this sort condition
 * @param {string} props.collection - Data collection being sorted
 * @returns {JSX.Element} Sort field and order selector with remove button
 */
import { getFieldObj } from "../../../utils/helpers";
import {
  sortOrders_boolean,
  sortOrders_date,
  sortOrders_quantity,
  sortOrders_text,
} from "./sort-section";

const SortItem = ({ id, field, fields, update, remove, collection }) => {
  const [sortOrdersSelection, setSortOrdersSelection] = useState([]);

  const getInitialSortOrder = (type) => {
    if (type === "quantity") {
      return sortOrders_quantity[0].value;
    }
    if (type === "text") {
      return sortOrders_text[0].value;
    }
    if (type === "date") {
      return sortOrders_date[0].value;
    }
    if (type === "boolean") {
      return sortOrders_boolean[0].value;
    }
  };

  useEffect(() => {
    if (field.type === "quantity") {
      setSortOrdersSelection(sortOrders_quantity);
    }
    if (field.type === "text") {
      setSortOrdersSelection(sortOrders_text);
    }
    if (field.type === "date") {
      setSortOrdersSelection(sortOrders_date);
    }
    if (field.type === "boolean") {
      setSortOrdersSelection(sortOrders_boolean);
    }
  }, [field.actualName]);

  return (
    <div className={styles.sortitemdiv}>
      <select
        className={`${styles["form-cell"]} ${styles["grow"]}`}
        onChange={(e) => {
          update({
            ...field,
            actualName: e.target.value,
            type: getFieldObj(collection, e.target.value).type,
            sortOrder: getInitialSortOrder(
              getFieldObj(collection, e.target.value).type
            ),
          });
        }}
        value={field.actualName}
      >
        {fields.map((field, index) => (
          <option key={index} className="option" value={field.actualName}>
            {field.displayName}
          </option>
        ))}
      </select>

      <select
        className={`${styles["form-cell"]} ${styles["grow"]}`}
        onChange={(e) => {
          update({ ...field, sortOrder: e.target.value });
        }}
        value={field.sortOrder}
      >
        {sortOrdersSelection.map((order, index) => (
          <option key={index} className="option" value={order.value}>
            {order.display}
          </option>
        ))}
      </select>

      <div
        className={`${styles["form-cell"]} ${styles["condition-icon"]} ${styles["pointer"]}`}
        onClick={() => remove(id)}
      >
        <BiTrash />
      </div>
    </div>
  );
};

export default SortItem;
